import "../../node_modules/van11y-accessible-tab-panel-aria/dist/van11y-accessible-tab-panel-aria.js";
